import { render, staticRenderFns } from "./GoCardlessPayment.vue?vue&type=template&id=688b8b86&scoped=true&"
import script from "./GoCardlessPayment.vue?vue&type=script&lang=js&"
export * from "./GoCardlessPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b8b86",
  null
  
)

export default component.exports